import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Dialog, DialogContent, DialogActions, DialogTitle, IconButton } from "@mui/material";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
import RenderContent from "./RenderContent";
import RenderFooter from "./RenderFooter";
import municipalityAPI from "../../../Network/Municipality";

const cookies = new Cookies();

export default function FormContainer({ object, openForm, setOpenForm, loadData }) {
    const [t] = useTranslation("common");
    const maintheme = useSelector((state) => state.themeData.maintheme);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        code: "",
        enabled: 1,
    });

    useEffect(() => {
        if (object) {
            setFormData({
                name: object?.name || "",
                code: object?.code || "",
                enabled: object?.enabled ?? 1,
            });
        }
    }, [object]);

    const handleClose = () => {
        setOpenForm(false);
    };

    const handleSubmit = async () => {
        if (!formData.name) {
            toast.error(t("MUNICIPALITIES.name_required") || "الاسم مطلوب");
            return;
        }

        setLoading(true);
        try {
            let result;
            if (object?.id) {
                result = await municipalityAPI.editMunicipality({
                    id: object.id,
                    data: formData,
                });
            } else {
                result = await municipalityAPI.addMunicipality({
                    data: formData,
                });
            }

            if (result?.status && result?.data?.status) {
                toast.success(
                    object?.id
                        ? t("NETWORK_MESSAGES.updateSuccess") || "تم التحديث بنجاح"
                        : t("NETWORK_MESSAGES.addSuccess") || "تمت الإضافة بنجاح"
                );
                handleClose();
                loadData();
            } else {
                toast.error(
                    result?.data?.data?.message || t("NETWORK_MESSAGES.unknownError")
                );
            }
        } catch (error) {
            toast.error(t("NETWORK_MESSAGES.unknownError"));
        }
        setLoading(false);
    };

    return (
        <Dialog
            open={openForm}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: "12px",
                },
            }}
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    backgroundColor: maintheme?.primary,
                    color: "#fff",
                    fontFamily: "Cairo-Bold",
                }}
            >
                {object?.id
                    ? t("MUNICIPALITIES.edit_title") || "تعديل البلدية"
                    : t("MUNICIPALITIES.add_title") || "إضافة بلدية"}
                <IconButton onClick={handleClose} sx={{ color: "#fff" }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ padding: "24px" }}>
                <RenderContent formData={formData} setFormData={setFormData} />
            </DialogContent>
            <DialogActions sx={{ padding: "16px 24px" }}>
                <RenderFooter
                    handleClose={handleClose}
                    handleSubmit={handleSubmit}
                    loading={loading}
                    isEdit={!!object?.id}
                />
            </DialogActions>
        </Dialog>
    );
}
